// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ac332b7","453":"02e7dfe7","732":"e6ac5cab"}[chunkId] + ".chunk.js";
};